// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"18":"Edit","362":"Dashboard","768":"Preview"}[chunkId] + "." + {"18":"74e60833","362":"2064c387","768":"2064c387"}[chunkId] + ".chunk.css";
};